<template>
    <el-dialog :visible.sync="visible" title="年级科目汇总统计" append-to-body :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
            :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="学科" prop="type">
                <el-select v-model="courseId" clearable placeholder="请选择" @change="subjectChange">
                    <el-option
                    v-for="item in subjectList"
                    :key="item.courseId"
                    :label="item.courseName"
                    :value="item.courseId">
                    </el-option>
                </el-select>
            </el-form-item>
            <div v-if="this.courseId" class="information">参考年级：        
            <div v-for="item in gradeList" :key="item.id">
                {{ item.gradeName }}{{ '、' }}
            </div>
            </div>   
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="batchExport()">导出</el-button>
        </template>
        <HtmlPanel v-if="htmlPanelVisible" ref="htmlPanel"></HtmlPanel>
    </el-dialog>
</template>
  
<script>

import { Loading } from 'element-ui'
import qs from 'qs'
import Cookies from 'js-cookie'

export default {
    name: 'teaching-quality-export',
    methods: {
        init(selectList) {
            this.visible = true
            this.examId = selectList[0].id
            this.getSubjectList()
            // this.dataForm.examMassAnalysisDTOS = selectList
        },
        getSubjectList(){
                this.$http.get('exam/exam/getCourseByExamId/'+this.examId).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.subjectList = res.data
            }).catch(() => { })
        },
        subjectChange(){
            console.log(this.courseId)
            this.$http.get('exam/exam/getGradeByCourse/'+this.examId+'/'+this.courseId).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.gradeList = res.data
            }).catch(() => { })
        },
        batchExport() {
            // const loadingInstance = Loading.service(this.loadOptions)           
                    const params = qs.stringify({
                    //     examId: this.examId,
                    //     courseId: this.courseId
                        token: Cookies.get('token')
                    })
                    window.open(
                        // `${window.SITE_CONFIG.apiURL}/exam/examClass/exportGradeResultTotal/?${params}`
                        `${window.SITE_CONFIG.apiURL}/exam/examClass/exportGradeResultTotal`+'/'+this.examId+'/'+this.courseId+'?'+params
                    )
                    this.$message({
                        message: this.$t('prompt.success'),
                        type: 'success',
                        duration: 500,
                        onClose: () => {
                            this.visible = false
                            this.$emit('refreshDataList')
                        }
                    })
                .catch((e) => {
                    // loadingInstance.close()
                    return this.$message.error('导出失败')
                })
        }
    },
    data() {
        return {
            visible: false,
            htmlPanelVisible: false,
            dataForm: {
                examMassAnalysisDTOS: [],
                type: []
            },
            examId: undefined,
            courseId: undefined,
            subjectList: [],
            gradeList: [],
        }
    },
    components: {}
}
</script>

<style scoped>
  .information{
  display: flex;
  justify-content: flex-start;
  padding-bottom: 10px;
}
.interval{
  padding-right:30px ;
}
</style>
  